import { Extension } from '@tiptap/core';
import { TableHandlesPlugin } from '../../private/plugins/TableHandlesPlugin';
import { dragHandlerStateFactory } from '../../private/states/TableHandlerState';

export const tableHandleExtension = Extension.create({
  name: 'tableHandle',
  addStorage() {
    return {
      dragHandlerState: dragHandlerStateFactory(),
    };
  },
  addProseMirrorPlugins() {
    return [
      TableHandlesPlugin({ dragHandlerState: this.storage.dragHandlerState }),
      //! DO NOT ENABLE THIS. it have some bugs, and inconsistent behavior.
      // TableDragPlugin(),
    ];
  },
});
